module.exports = __webpack_public_path__ + "static/media/Edit.918dfd75.svg";